import React, {useState, useRef} from "react";
import Rocket from "../../../assets/icons/rocket.svg";
import User from "../../../assets/icons/user.svg";
import Misc1 from "../../../assets/misc/9.svg";
import Misc2 from "../../../assets/misc/11.svg";
import Misc3 from "../../../assets/misc/7.svg";
import Misc4 from "../../../assets/misc/8.svg";
import Misc5 from "../../../assets/misc/10.svg";
import Shadow from "../../../assets/shadows/5.png";
import ShadowBack from "../../../assets/shadows/7.png";
import avatar1 from "../../../assets/avatar/Ron_Jarmin.png";
import avatar2 from "../../../assets/avatar/Stefan_Schweinfest.png";
import avatar3 from "../../../assets/avatar/Bert_Kroese.png";
import avatar4 from "../../../assets/avatar/Tom_Smith.png";
import Carousel from "react-multi-carousel";

const About = () => {
  const details = [
    {
      id: 0,
      quote: "The current methods for collecting and disseminating statistical information are not sustainable. We realize the importance of Privacy Enhancing Technologies as critical to how we deliver on our mission.",
      avatar: avatar1,
      name: "Ron Jarmin",
      position: "Deputy director of the US Census Bureau",
    },
    {
      id: 1,
      quote: "Senior leaders are now talking about Privacy Enhancing Technologies to enable cross-border and cross-sector collaboration to solve shared challenges. At the same time, PETs will protect shared values such as privacy, accountability, and transparency.",
      avatar: avatar2,
      name: "Stefan Schweinfest",
      position: "Director of the UN Statistics Division",
    },
    {
      id: 2,
      quote: "National Statistical Offices have the obligation and a long history in protecting privacy while enabling access to useful insight. PETs are promising ways to provide additional privacy protection while still allowing useful and important analyses on new data sources.",
      avatar: avatar3,
      name: "Bert Kroese",
      position: "Chief Statistician of the International Monetary Fund (IMF)",
    },
    {
      id: 3,
      quote: "With the PET Lab, we are exploring how multiple organisations, such as statistics offices, can carry out ‘federated analysis’ across their data sources while retaining confidentiality of those sources.",
      avatar: avatar4,
      name: "Tom Smith",
      position: "Former Director of the UK Data Science Campus at the Office for National Statistics",
    },
  ];

  const [selectedAvatar, setSelectedAvatar] = useState(window.innerWidth < "464" ? 0 : window.innerWidth < "1024" ? 1 : (details.length > 5 ? 2 : 1));
  const carouselRef = useRef();
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: details.length > 5 ? 5 : 3,
      slidesToSlide: 1,
      currentSlide: selectedAvatar,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1,
      currentSlide: selectedAvatar,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
      currentSlide: selectedAvatar,
    }
  };

  const carouselSlide = (previousSlide, { currentSlide, onMove }) => {   
    if(window.innerWidth > "1024") setSelectedAvatar(details.length > 5 ? (currentSlide + 2 ) % details.length : (currentSlide + 1 ) % details.length);
    else if(window.innerWidth > "464") setSelectedAvatar((currentSlide + 1) % details.length);
    else setSelectedAvatar((currentSlide-2) % details.length);
  }

  return (
    <div className="w-full relative lg:mb-[120px] md:mb-[80px] sm:mb-[60px] mb-[50px]">
      <div className="flex flex-col sm:gap-36 gap-20 w-full sm:max-w-container max-w-[90vw] mx-auto relative z-10">
        <div className="relative flex gap-20 sm:pb-[150px] pb-20 border-dashed border-b border-b-[#00000040] md:flex-row flex-col">
          <div className="w-full max-w-[288px] ml-5">
            <img
              src={Misc1}
              className="absolute top-5 sm:top-0 left-[min(90%,360px)] sm:left-[128px] -translate-y-full"
              alt=""
            />
            <p className="uppercase font-semibold text-warning text-sm mb-8">
              About
            </p>
            <p className="relative font-semibold md:text-5xl text-4xl text-dark md:leading-tight">
              What is the UN PET Lab?
              <img
                src={Misc2}
                className="absolute -bottom-[18px] sm:-left-9 -left-4"
                alt=""
              />
            </p>
          </div>
          <div className="flex sm:flex-row flex-col gap-10 justify-around w-full sm:items-start items-center">
            <div className="flex flex-col sm:items-start items-center sm:text-left text-center w-full max-w-[394px]">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-success shadow-icon mb-6">
                <img src={Rocket} />
              </div>
              <p className="font-semibold text-2xl text-dark mb-4 leading-normal">
                Launched in 2020
              </p>
              <p className="text-xl text-dark leading-normal opacity-70">
                Launched at EXPO 2020 by the UN Committee of Experts on Big Data
                and Data Science for Official Statistics.
              </p>
            </div>
            <div className="flex flex-col sm:items-start items-center sm:text-left text-center w-full max-w-[394px]">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-success shadow-icon mb-6">
                <img src={User} />
              </div>
              <p className="font-semibold text-2xl text-dark mb-4 leading-normal">
                Confidential Collaboration
              </p>
              <p className="text-xl text-dark leading-normal opacity-70">
                The lab brings together national statistics bureaus, researchers
                and PET providers to work through the challenges in safely
                utilising the world's most important information.
              </p>
            </div>
          </div>
        </div>
        
        <div className="relative">
          <img
            src={Shadow}
            className=" -z-20 absolute md:-left-[7.5vw] -left-[30vw] md:-top-[90%] -top-[50%] opacity-40 min-w-[1080px]"
            alt=""
          />
          <img
            src={Misc4}
            className="absolute lg:right-7 right-2 -top-[5%] md:w-[10%] sm:w-[15%] w-[20%] max-w-[120px]"
          />
          <img
            src={Misc5}
            className="absolute left-4 top-96 -translate-y-1/2 lg:block hidden"
          />
          <div className="w-full flex flex-col items-center max-w-5xl mx-auto">
            <img src={Misc3} className="mb-12" alt="" />
            <p key={"avatar"+ details[selectedAvatar]?.id} 
              className="appearDissapear smooth w-full max-w-5xl lg:h-96 md:h-80 h-56 overflow-visible mb-16 font-medium lg:text-[40px] md:text-[30px] sm:text-[24px] text-lg lg:px-0 px-[10vw] leading-tight text-dark text-center">
              {details[selectedAvatar]?.quote}
            </p>
            <div className="relative flex flex-col items-center w-full">
              <img
                src={ShadowBack}
                className=" -z-20 absolute -top-[150%] opacity-50 min-w-[1080px]"
              />
              <div className="absolute top-14 sm:top-[3.75rem] md:top-[4.25rem] h-0 w-[70vw] max-w-[1080px] border-b-[2px] border-dashed border-b-[#14203820] z-[-5]"></div>
              <div className="lg:w-full w-[70vw]">
                <Carousel
                  autoPlay={true}
                  autoPlaySpeed={7000}
                  infinite={true}
                  ref={carouselRef}
                  responsive={responsive}
                  arrows={false}
                  afterChange={carouselSlide}
                  draggable={false}
                  swipeable={false}
                >
                  {details.map((item, index) => (
                    <div key={index} className={" select-none flex flex-col items-center pt-6 "+ (index == selectedAvatar? "-mt-4" : " ")}>
                      
                      <div className={"mb-4 rounded-full smooth select-none" + (index == selectedAvatar ? " bg-white zoom opacity-100" : " faded opacity-75")}>
                        <img src={item.avatar} className={" md:w-32 w-24 p-4 rounded-full"} />
                      </div>
                      
                      <div className="w-full max-w-[264px] flex flex-col items-center sm:h-48 h-32 mt-4">
                        <span className={"font-semibold lg:text-2xl md:text-xl sm:text-base text-sm leading-tight text-dark mb-2 text-center smooth"
                          + (index === selectedAvatar ? " opacity-100" : " opacity-0")}>
                          {item.name}
                        </span>
                        <span className={"overflow-visible font-medium lg:text-base text-xs md:text-sm uppercase text-center text-black leading-5 smooth"
                          + (index === selectedAvatar ? " opacity-40" : " opacity-0")}>
                          {item.position}
                        </span>
                      </div>
                      
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
